import sagaResourceConstants from 'utils/saga-resource/constants';

export const ERROR = sagaResourceConstants.ACTION_TYPE_ERROR;
